module.exports = __webpack_public_path__ + "img/MGH-Roppongi-5-2440x1172.454da9de.jpg";